import React from 'react';
import PropTypes from 'prop-types';
import Select from 'components/Select/Select';
import baseStyles from 'components/Select/Select.styled';

const statisticsSelectStyles = {
  ...baseStyles,
  option: (prev, state) => ({
    ...baseStyles.option(prev, state),
    padding: '12px 0 12px 32px',
  }),
};

const StatisticsSelect = (props) => (
  <Select
    {...props}
    styles={statisticsSelectStyles}
  />
);

StatisticsSelect.propTypes = {
};

export default StatisticsSelect; 